import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quote, ArrowRight } from "lucide-react";

export default function FeaturedStoryTicker({ stories }) {
  const withProof = (stories || []).filter((s) => s.quote || s.result);
  const featured = withProof.filter((s) => s.featured);
  const items = featured.length > 0 ? featured : withProof;
  const [idx, setIdx] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (items.length <= 1) return;
    const t = setInterval(() => {
      setShow(false);
      setTimeout(() => { setIdx((i) => (i + 1) % items.length); setShow(true); }, 350);
    }, 5000);
    return () => clearInterval(t);
  }, [items.length]);

  if (items.length === 0) return null;
  const c = items[idx];

  return (
    <Link
      to={`/success-stories/${c.slug}`}
      data-testid="hero-featured-story"
      className="animate-fade-up mt-6 group flex items-start gap-3 max-w-md bg-white/10 hover:bg-white/[0.16] backdrop-blur-sm border border-white/15 rounded-2xl p-4 transition-colors"
      style={{ animationDelay: "0.35s" }}
    >
      <span className="w-9 h-9 rounded-full bg-orange flex items-center justify-center shrink-0"><Quote size={16} className="text-white" /></span>
      <div className={`min-w-0 transition-opacity duration-300 ${show ? "opacity-100" : "opacity-0"}`}>
        <p className="text-[11px] font-bold text-orange uppercase tracking-wider">{c.result || "Client success story"}</p>
        <p className="text-sm text-white/90 italic leading-snug mt-0.5 line-clamp-2">{c.quote ? `“${c.quote}”` : c.title}</p>
        <span className="text-xs text-slate-300 mt-1.5 inline-flex items-center gap-1 group-hover:text-white group-hover:gap-2 transition-all">{c.client_name || "Read the story"} <ArrowRight size={12} /></span>
      </div>
    </Link>
  );
}
